"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NoTranslate;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Wrap the text prop in a var tag
// If children are passed instead of text, add a notranslate attr to each child
function NoTranslate(props) {
  var text = props.text,
      children = props.children;

  if (text) {
    return /*#__PURE__*/_react.default.createElement("var", null, text);
  }

  var noTranslatedChildren = _react.default.Children.map(children, function (child) {
    if (typeof child === 'string') {
      return /*#__PURE__*/_react.default.createElement("var", null, child);
    }

    return /*#__PURE__*/_react.default.cloneElement(child, {
      notranslate: 'notranslate'
    });
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, noTranslatedChildren);
}

NoTranslate.defaultProps = {
  text: '',
  children: ''
};
NoTranslate.propTypes = {
  text: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/base/NoTranslate.js
// module id = 538
// module chunks = 0 15 16 17 18